import { Image, Text } from '@ui/atoms';

const FDWhyStep = ({ step }) => {
    const { icon, title, description } = step;
    return (
        <div className="flex flex-col items-center gap-3 p-3 md:gap-6 md:p-6 bg-basicWhite rounded-xl shadow-fd-why-card max-w-[320px] md:max-w-[238px] h-full">
            <Image
                src={`/images/products/${icon}.svg`}
                alt={`${title} icon`}
                className="w-[60px] h-[60px]"
            />
            <div className="flex flex-col items-center gap-1 text-basicBlack ">
                <Text content={title} className=" p4-semibold" />
                <Text
                    content={description}
                    className="text-center p5-regular"
                />
            </div>
        </div>
    );
};

export default FDWhyStep;
